import router from './index.ts'
import { useLocalStorage } from '@/hooks/web/useStorage'
import { _isMobile } from '@/utils/is'
import { NavigationGuardNext, RouteLocationNormalizedGeneric } from 'vue-router'

const localStorage = useLocalStorage()

// 路由白名单配置
const ROUTE_WHITELIST = ['NoFind', 'share', 'personal', 'commodity', 'payCallbackPage', 'coupon', 'column', 'wxOauth']

// 设备相关路由映射
const DEVICE_ROUTES_NAME = {
  mobile: ['Mobile', 'CodeView'],
  pc: ['Live']
}

/**
 * 路由前置守卫
 * 1. 处理未命名路由
 * 2. 处理支付回调
 * 3. 校验是否是允许访问的路由
 * 4. 根据设备适配重定向到对应URL
 */
router.beforeEach(
  async (to: RouteLocationNormalizedGeneric, from: RouteLocationNormalizedGeneric, next: NavigationGuardNext) => {
    console.log(`permission-before -----> from name: ${from.name as string}`)
    // 处理未命名路由
    if (!to.name && !ROUTE_WHITELIST.some(name => to.name === name)) {
      return next('/nopremission/1')
    }

    // 处理支付回调
    if (to.params.id?.includes('COMMODITYINFO')) {
      return handlePaymentRedirect(to, next)
    }

    // 校验是否是允许访问的路由
    const isAllowed = [...DEVICE_ROUTES_NAME[_isMobile() ? 'mobile' : 'pc'], ...ROUTE_WHITELIST].some(
      name => to.name === name
    )

    if (!isAllowed) {
      // 不是正确URL，根据设备适配重定向到对应URL
      const queryParams = {
        ...(to.query.data && { data: to.query.data }),
        ...(to.query.code && { code: to.query.code })
      }
      return next({
        path: `${_isMobile() ? '/mobile' : '/live'}/${to.params.id}`,
        query: queryParams
      })
    }
    next()
  }
)

/**
 * 处理聚合支付回调重定向
 */
const handlePaymentRedirect = (to: RouteLocationNormalizedGeneric, next: NavigationGuardNext) => {
  try {
    const fullId = to.params.id as string
    const infoIndex = fullId.indexOf('COMMODITYINFO')
    const orderIndex = fullId.indexOf('ORDERID')

    if (infoIndex === -1 || orderIndex === -1) return

    const orderId = fullId.substring(infoIndex + 13, orderIndex)
    const baseId = fullId.substring(0, infoIndex)

    console.log('commodity_payInfo', orderId, baseId)
    localStorage.set('commodity_payInfo', orderId)

    const query = to.query.data ? { data: to.query.data } : {}
    next({ path: `/mobile/${baseId}`, query })
  } catch (error) {
    console.error('支付回调处理失败:', error)
    next('/nopremission/1')
  }
}
